import { useKeycloak } from '@/contexts/KeycloakContext';
import { Button } from '@/styles/buttons';
import { Row } from '@/styles/common';
import React from 'react';
import { NavLink } from 'react-router-dom';
import CurrentPage from './CurrentPage';
import { Logo, NavbarContainer } from './navbar.style';

interface NavbarProps {}

const Navbar: React.FC<NavbarProps> = () => {
	const { keycloak } = useKeycloak();

	return (
		<NavbarContainer>
			<NavLink to='/'>
				<Logo src='/logo.jpg' alt='logo' />
			</NavLink>
			<CurrentPage />
			<Row center className='full'>
				<p>{keycloak?.idTokenParsed?.email as string}</p>
				<Button onClick={() => keycloak?.logout()}>Logout</Button>
			</Row>
		</NavbarContainer>
	);
};

export default Navbar;
